<template>
  <div class="bc-page">
    <div class="bc-card">
      <img src="/img/logo.png" alt="Floor Plan Mapper" class="bc-logo">

      <div v-if="loading">
        <b-spinner variant="primary" class="bc-spinner" />
        <p class="bc-text-muted">Processing your request...</p>
      </div>

      <div v-else-if="result === 'confirmed'">
        <div class="bc-icon bc-icon--success">&#10003;</div>
        <h3 class="bc-title bc-title--success">Booking Confirmed</h3>
        <p class="bc-text-muted">Your desk booking has been confirmed. See you there!</p>
      </div>

      <div v-else-if="result === 'cancelled'">
        <div class="bc-icon bc-icon--danger">&#10007;</div>
        <h3 class="bc-title bc-title--danger">Booking Cancelled</h3>
        <p class="bc-text-muted">Your desk booking has been cancelled successfully.</p>
      </div>

      <div v-else-if="result === 'cancelled_set'">
        <div class="bc-icon bc-icon--danger">&#10007;</div>
        <h3 class="bc-title bc-title--danger">Recurring Bookings Cancelled</h3>
        <p class="bc-text-muted">All future recurrences of this desk booking have been cancelled.</p>
      </div>

      <div v-else-if="error === 'expired'">
        <div class="bc-icon bc-icon--warning">&#9719;</div>
        <h3 class="bc-title bc-title--warning">Link Expired</h3>
        <p class="bc-text-muted">This confirmation link has expired. Links are valid for 24&nbsp;hours.</p>
        <p class="bc-text-hint">Please contact your administrator if you need assistance.</p>
      </div>

      <div v-else-if="error === 'used'">
        <div class="bc-icon bc-icon--info">&#8505;</div>
        <h3 class="bc-title bc-title--info">Already Processed</h3>
        <p class="bc-text-muted">This link has already been used.</p>
      </div>

      <div v-else>
        <div class="bc-icon bc-icon--danger">&#33;</div>
        <h3 class="bc-title bc-title--danger">Something Went Wrong</h3>
        <p class="bc-text-muted">{{ errorMessage || 'This link is invalid or has already expired.' }}</p>
      </div>

      <div class="bc-footer">
        <a href="/" class="bc-footer__link">Floor Plan Mapper</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BookingConfirm',
  data: () => ({
    loading: true,
    result: null,
    error: null,
    errorMessage: null
  }),
  async mounted() {
    const token  = this.$route.query.token
    const action = this.$route.query.action

    if (!token || !action) {
      this.error = 'invalid'
      this.loading = false
      return
    }

    try {
      const response = await axios.post('/api/v1/desk-event-confirmation', { token, action })
      this.result = response.data.action
    } catch (err) {
      const status = err.response?.status
      if (status === 410) {
        this.error = 'expired'
      } else if (status === 409) {
        this.error = 'used'
      } else {
        this.error = 'invalid'
        this.errorMessage = err.response?.data?.errors?.token?.[0]
            || err.response?.data?.errors?.general?.[0]
            || null
      }
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.bc-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  padding: 20px;
  box-sizing: border-box;
}

.bc-card {
  max-width: 480px;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  padding: 40px 32px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.10);
}

.bc-logo {
  max-height: 50px;
  margin-bottom: 24px;
}

.bc-spinner {
  width: 3rem;
  height: 3rem;
}

.bc-icon {
  font-size: 56px;
}

.bc-icon--success { color: #28a745; }
.bc-icon--danger  { color: #dc3545; }
.bc-icon--warning { color: #ffc107; }
.bc-icon--info    { color: #17a2b8; }

.bc-title {
  margin-top: 8px;
}

.bc-title--success { color: #28a745; }
.bc-title--danger  { color: #dc3545; }
.bc-title--warning { color: #856404; }
.bc-title--info    { color: #17a2b8; }

.bc-text-muted {
  color: #555;
}

.bc-text-hint {
  color: #888;
  font-size: 13px;
}

.bc-footer {
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.bc-footer__link {
  color: #6c757d;
  font-size: 13px;
  text-decoration: none;
}
</style>
